import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "s10_mobile flex flex-col justify-content-center h-100p container-full-5" }
const _hoisted_3 = { class: "container-full-10" }

import { inject, onMounted, onUnmounted, reactive, ref, toRaw } from 'vue';
    import { useRouter } from 'vue-router';
    import LoginForm from './LoginForm.vue';
    import RenewExpiredPasswordForm from './RenewExpiredPasswordForm.vue';
    import VerificationOtpForm from './VerificationOtpForm.vue';
    import RegistrationOtpForm from './RegistrationOtpForm.vue';
    import axios from 'axios';
    import { API_INFOS$, APP_INFOS } from '@/appService';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

    const APP_ENV = inject('APP_ENV');
    const router = useRouter();
    const errorMessage = ref('');
    const loading = ref(false);
    const authResponse = reactive({
        token: '',
        password_expired: 1,
        mfa_enabled: 1
    });
    const currentViewName = ref<'LOGIN_VIEW' | 'RENEW_EXPIRED_PASSWORD' | 'REGISTRATION_OTP' | 'VERIFICATION_OTP'>('LOGIN_VIEW');
    const appInfos = reactive(APP_INFOS);
    const apiInfos = reactive({
        app_name: '',
        app_commit_sha: '',
        app_version: ''
    });

    onMounted(() => {
        const sub = API_INFOS$.subscribe(_apiInfos => {
            apiInfos.app_name = _apiInfos.app_name;
            apiInfos.app_commit_sha = _apiInfos.app_commit_sha;
            apiInfos.app_version = _apiInfos.app_version;
        });
        onUnmounted(() => sub.unsubscribe());
    })

    async function onAuthenticated(data: any) {
        authResponse.token = data.token;
        authResponse.password_expired = data.password_expired;
        authResponse.mfa_enabled = data.mfa_enabled;

        //if (APP_ENV == 'test') {
            redirectAuth();
        /*} else {
            if (data.password_expired == 1) {
                currentViewName.value = 'RENEW_EXPIRED_PASSWORD';
            } else if (data.mfa_enabled == 0) {
                currentViewName.value = 'REGISTRATION_OTP';
            } else {
                currentViewName.value = 'VERIFICATION_OTP';
            }
        }*/
    }

    function onPasswordRenewed() { 
        if (authResponse.mfa_enabled == 0) {
            currentViewName.value = 'REGISTRATION_OTP';
        } else {
            currentViewName.value = 'VERIFICATION_OTP';
        }
    }

    function onOtpRegistered() {
        currentViewName.value = 'VERIFICATION_OTP';
    }

    async function onOtpCodeVerified() {
        redirectAuth();
    }

    async function doGetAuthSession() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const user = (await axios.get('/backoffice/auth/user', { headers: { Authorization: `Bearer ${authResponse.token}` } })).data;
            localStorage.setItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN', authResponse.token);
            localStorage.setItem('LS_COOP_FINANCE_BO_AUTH_USER', JSON.stringify(user));
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function redirectAuth() {
        await doGetAuthSession();
        await router.replace('/app/dashboard');
    }

    function printAppInfos() {
        console.log("API INFOS", toRaw(apiInfos));
        console.log("APP INFOS", toRaw(appInfos));
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("section", { class: "s10_mobile px-4 py-4 h-100p" }, [
      _createElementVNode("div", {
        class: "widget s20_mobile h-100p flex align-items-center justify-content-center",
        style: {"background":"url('/images/bg-connexion.jpg') no-repeat center center","background-size":"cover"}
      }, [
        _createElementVNode("img", {
          src: "/icons/icon-menu-securite.svg",
          width: "20%",
          class: "icon-white"
        })
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center mb-8" }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "60%"
          })
        ], -1)),
        (currentViewName.value == 'LOGIN_VIEW')
          ? (_openBlock(), _createBlock(LoginForm, {
              key: 0,
              onAuthenticated: onAuthenticated
            }))
          : (currentViewName.value == 'RENEW_EXPIRED_PASSWORD')
            ? (_openBlock(), _createBlock(RenewExpiredPasswordForm, {
                key: 1,
                "access-token": authResponse.token,
                onPasswordRenewed: onPasswordRenewed
              }, null, 8, ["access-token"]))
            : (currentViewName.value == 'REGISTRATION_OTP')
              ? (_openBlock(), _createBlock(RegistrationOtpForm, {
                  key: 2,
                  "access-token": authResponse.token,
                  onOtpRegistered: onOtpRegistered
                }, null, 8, ["access-token"]))
              : (currentViewName.value == 'VERIFICATION_OTP')
                ? (_openBlock(), _createBlock(VerificationOtpForm, {
                    key: 3,
                    "access-token": authResponse.token,
                    onOtpVerified: onOtpCodeVerified
                  }, null, 8, ["access-token"]))
                : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (printAppInfos())),
          class: "s20 text-center justify-content-center",
          style: {"cursor":"pointer","margin-top":"50px","padding":"10px 30px","box-shadow":"rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px"}
        }, [
          _createElementVNode("span", null, "v" + _toDisplayString(appInfos.app_version), 1)
        ])
      ])
    ])
  ]))
}
}

})